<script setup lang="ts">
import WhatsAppUnavailable from '@/shared/components/Warnings/WhatsAppUnavailable.vue';
</script>

<template>
  <WhatsAppUnavailable>
    <a
      href="https://wa.me/79035192590"
      target="_blank"
      class="c-call__outer"
      data-stickyeah-offset="120"
    >
      <div class="c-call">
        <div class="c-call__content">
          <img
            src="@/shared/assets/img/call/icon-call.svg"
            alt=""
          />
          <div class="c-call__text">Напиши<br>менеджеру</div>
        </div>
      </div>
      <img
        src="@/projects/mti/assets/img/call/call-mobile.svg"
        class="c-call__mobile"
        alt=""
      />
    </a>
  </WhatsAppUnavailable>
</template>

<style lang="scss">
@import "./TheCall.scss";
</style>
